import { useLocalStorage } from 'usehooks-ts';
import { useEffect } from 'react';
import useListenFromRn from '../utilities/useListenFromRn';
import { createOrUpdateLiveNotification, updateNotificationLog } from '@/lib/db/DBNotificationHelpers';
import useGetLocation from '../utilities/useGetLocation';
import useAppDetails from '../utilities/useAppDetails';
export default function useSetExpoToken(PKP) {
  const {
    useRNHandler
  } = useListenFromRn();
  const [expoPushToken, setExpoPushToken] = useLocalStorage('expoPushToken', '');
  const [_, setBlockApp] = useLocalStorage('blockApp', false);
  const [deviceData, setDeviceData] = useLocalStorage('deviceData', {});
  const {
    data: locationData
  } = useGetLocation();
  const {
    isAppleNativeApp,
    isGoogleNativeApp
  } = useAppDetails();
  useRNHandler('EXPO_PUSH_TOKEN', payload => {
    console.log('EXPO_PUSH_TOKEN', payload);
    try {
      payload = JSON.parse(payload);
    } catch (_) {
      //
    }
    if (payload) {
      setExpoPushToken(payload.expo_token);
      setDeviceData(payload.device_data);
    }
  });
  useRNHandler('BLOCK_APP', payload => {
    console.log('BLOCK_APP', payload);
    try {
      payload = JSON.parse(payload);
    } catch (_) {
      //
    }
    if (payload.block) {
      setBlockApp(true);
    } else {
      setBlockApp(false);
    }
  });
  useRNHandler('NOTIFICATION_CLICK', payload => {
    console.log('NOTIFICATION_CLICK', payload);
    try {
      payload = JSON.parse(payload);
    } catch (_) {
      //
    }
    if (payload) {
      updateNotificationLog(payload.notification_id, {
        status: 'clicked'
      });
    }
  });
  useEffect(() => {
    if (expoPushToken) {
      // LogToMixpanel({
      //   pkp: PKP,
      //   eventName: EVENTS.auth.notif_token,
      //   category: CATEGORIES.auth,
      //   metaData: {
      //     expo_token: expoPushToken,
      //   },
      // });
      createOrUpdateLiveNotification({
        expo_token: expoPushToken,
        location_data: locationData,
        device_data: deviceData,
        pkp_eth_address: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress,
        token_type: isAppleNativeApp ? 'apple_native' : isGoogleNativeApp ? 'google_native' : 'native'
      });
    }
  }, [expoPushToken, PKP]);
}